import React from 'react';

function get_coords(radian_interval, radius) {
    return {
        x: Math.cos(radian_interval) * radius,
        y: Math.sin(radian_interval) * radius
    }
}

function Card(props) {
    let coord = get_coords(props.radian_interval, props.radius);
   
    return (
        <div className={props.classname} style={{ ...styles.card, transform: `translate(-50%, -50%) rotate(${props.getInnerRotate()}deg)`, left: `${props.center.x + coord.x}px`, top: `${props.center.y - coord.y}px` }}>
        </div>
    )
}

const styles = {
    card: {
        margin: '0',
        padding: '0',
        width: '131px',
        height: '131px',
        backgroundSize:'contain',
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'none',
    }
}

export default Card;